import type { ReactNode } from 'react';
import type { AccountInfo } from './AccountMenu';
import { BottomNav } from './BottomNav';
import type { ConnectionState } from './ConnectionStatus';
import type { NavGroup } from './navModel';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export interface AppShellProps {
  groups: NavGroup[];
  bcv: number | null;
  unread: number;
  account: AccountInfo | null;
  connection: ConnectionState;
  /** Franja bajo la barra superior (p. ej. `ConnectionBanner`). */
  banner?: ReactNode;
  children: ReactNode;
}

/**
 * Carcasa: barra lateral (≥ 1024 px), barra superior, contenido y barra inferior móvil. El contenedor
 * `#contenido` es el destino del enlace «Saltar al contenido» y recibe el foco al cambiar de ruta.
 */
export function AppShell({
  groups,
  bcv,
  unread,
  account,
  connection,
  banner,
  children,
}: AppShellProps) {
  return (
    <div className="min-h-dvh bg-bg lg:grid lg:grid-cols-[16rem_minmax(0,1fr)]">
      <Sidebar groups={groups} />
      <div className="flex min-h-dvh min-w-0 flex-col">
        <Topbar bcv={bcv} unread={unread} account={account} connection={connection} />
        {banner}
        <main
          id="contenido"
          tabIndex={-1}
          className="flex-1 pb-[calc(var(--nav-h)+var(--safe-bottom))] outline-none lg:pb-0"
        >
          {children}
        </main>
      </div>
      <BottomNav
        groups={groups}
        unread={unread}
        onSignOut={account?.status === 'auth' ? account.onSignOut : undefined}
      />
    </div>
  );
}
